import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {CodingSchemaDTO} from '../models/CodingSchemaDTO';

@Injectable({
  providedIn: 'root'
})
export class CodingSchemaService {
  private url = environment.baseUrl + '/coding-schema';

  constructor(private httpClient: HttpClient) {
  }

  getListOfCodingSchemas(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<CodingSchemaDTO>> {
    return this.httpClient.post<PagedResponseDTO<CodingSchemaDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getListOfCodingSchemasByDescriptionAndType(description: string, codingSchemaTypeId: number): Observable<PagedResponseDTO<CodingSchemaDTO>> {
    const params = new HttpParams()
      .set('description', String(description))
      .set('codingSchemaTypeId', String(codingSchemaTypeId));
    return this.httpClient.get<PagedResponseDTO<CodingSchemaDTO>>(this.url + '/filterByDescriptionAndType', {params});
  }

  searchCodingSchemas(search: string, codingSchemaTypeId: number): Observable<PagedResponseDTO<CodingSchemaDTO>> {
    const request = new PagedRequestDTO();
    request.entityClass = 'TblCodingSchema';
    request.pageNumber = 0;
    request.pageSize = 20;
    request.sortField = 'code';
    request.sortDirection = 'ASCENDING';
    request.fieldMap = {
      codingSchemaType: {
        name: 'codingSchemaTypeByCodingSchemaTypeId.codingSchemaTypeId',
        operator: '==',
        value: String(codingSchemaTypeId),
        logicGate: 'AND'
      },
      code: {name: 'code', value: search, logicGate: 'AND', bracket: '('},
      shortDescription: {name: 'shortDescription', value: search, logicGate: 'OR', bracket: ')'}
    };
    return this.getListOfCodingSchemas(request);
  }
}
